import { render, staticRenderFns } from "./Films.vue?vue&type=template&id=10ead640&"
import script from "./Films.vue?vue&type=script&lang=js&"
export * from "./Films.vue?vue&type=script&lang=js&"
import style0 from "./Films.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports